<template>
<div id="dashboard" class="container panel">
	<div class="row">
      <div class="col-md-3 sidebar">
			<side-bar></side-bar>
      </div>
      <div class="col-md-9 content">
			<div class="dashhead">
  				<div class="dashhead-titles">
    				<h6 class="dashhead-subtitle">Password Security Portal</h6>
    				<h2 class="dashhead-title">Dashboard</h2>
  				</div>
			</div>

			<!-- Content Here -->

			
      </div>
	</div>
</div>
</template>

<script>
import SideBar from './SideBar'

export default {
	name: 'Dashboard',
	components: {SideBar}
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue